import React, { Component } from 'react';
import * as classes from './CustomFadeBox.module.scss';
import * as DataUtil from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";


class CustomFadeBox extends Component {
    constructor() {
        super();
        this.state = {}
    }

    onRemove = () => {
        const { onRemove, id } = this.props;
        onRemove(id);
    };

    render() {

        let data = DataUtil.sliceShortName(this.props.value, 15);
        return (
            <div className={classes.Box}>
                <div className={classes.Div} id={this.props.id} value={this.props.value} onClick={this.onRemove}>{data}</div>
            </div>
        )
    }
}

export default CustomFadeBox;


